import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Text, Button } from 'react-orange-ui';

import WordingService from '../../../services/WordingService';
import { MULTIBAL_ACCOUNT } from '../../../helpers/account';
import TagService from '../../../services/TagService';

const WithNewLine = styled(Text)`
  white-space: pre-wrap;
`;

class NoContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.accountLevel === MULTIBAL_ACCOUNT ? WordingService.getWording('caption', 'isNotOwnerAccount') : WordingService.getWording('caption', 'contactSAV'),
    };
  }

  /**
   * Quit app when click on "End" button
   * @param e
   */
  handleClick = (e) => {
    e.preventDefault();
    const { quitApp } = this.props;
    
    TagService.sendAction('endNoContact');
    quitApp();
  };

  render() {
    const { message } = this.state;

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <WithNewLine id="no-contact-message">
            {message}
          </WithNewLine>
          <br />
          <Button id="button-end" type="fill" onClick={this.handleClick}>
            {WordingService.getWording('button', 'end')}
          </Button>
        </Col>
      </Row>
    );
  }
}

NoContact.defaultProps = {
  accountLevel: 'PRINCIPAL',
  quitApp: () => { },
};

NoContact.propTypes = {
  accountLevel: PropTypes.oneOf(['NSRU', 'MULTIBAL', 'PRINCIPAL', 'EXTERNAL']),
  quitApp: PropTypes.func,
};

export default NoContact;
